import { Colors, Services, requisitesBases, requisitesOpfList, requisitesPositions } from '@sigma-frontend-libs/commons'
import { REQUISITE_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { components, sizes } from '@/utils'

import info from '@/components/info'
import radioCard from '@/components/radio/card'
import selectorOwner from '@/components/selector/owner'
import requisitesFormAddress from '@/components/services/requisites/form/address'
import { bikRegExp, innRegExp, kppRegExp, ksRegExp, ogrnRegExp, okpoRegExp, rsRegExp } from '@/components/services/requisites/utils'
import tag from '@/components/tag'

function renderValidation(h, state) {
  let validationColor = Colors.error
  if (state === true) {
    validationColor = Colors.success
  }

  return h(
    'div',
    {
      class: 'fjcfe'
    },
    [
      h(
        tag,
        {
          props: {
            label: this.getTranslate(`${Services.requisites}.hints.validation.state.${state}`),
            color: validationColor,
            size: sizes.small
          }
        }
      )
    ]
  )
}

function renderAutoFilling(h) {
  return h(
    components.card,
    {
      class: `${Services.requisites}-form__section`,
      props: {
        title: this.getTranslate(`${Services.requisites}.titles.autoFilling`),
        outline: true,
        rounded: true,
        dashed: true
      }
    },
    [
      h(
        'div',
        {
          class: `${Services.requisites}-form__row`
        },
        [
          h(
            components.select,
            {
              props: {
                value: this.suggestion.inn,
                label: this.getTranslate(`${Services.requisites}.labels.data.legal.inn`),
                hint: this.getTranslate(`${Services.requisites}.hints.suggestions.inn`),
                dense: true,
                details: true,
                clearable: true,
                combobox: true,
                hideSelections: true,
                loading: this.loading.inn,
                items: this.suggestions.inn,
                mask: /^\d{1,10}$|^\d{1,12}$/
              },
              on: {
                search: event => {
                  this.getRequisitesByInn(event)
                },
                input: event => {
                  this.suggestion.inn = event
                }
              },
              scopedSlots: {
                selection: ({ item }) => {
                  return h(
                    tag,
                    {
                      props: {
                        label: item.title,
                        as: 'select-dense'
                      }
                    }
                  )
                }
              }
            }
          ),
          h(
            components.select,
            {
              props: {
                value: this.suggestion.bank,
                label: this.getTranslate(`${Services.requisites}.labels.suggestions.bik`),
                hint: this.getTranslate(`${Services.requisites}.hints.suggestions.bik`),
                dense: true,
                details: true,
                clearable: true,
                combobox: true,
                hideSelections: true,
                loading: this.loading.bank,
                items: this.suggestions.bank
              },
              on: {
                search: event => {
                  this.getSuggestions(event, 'bank')
                },
                input: event => {
                  this.suggestion.bank = event
                }
              },
              scopedSlots: {
                selection: ({ item }) => {
                  return h(
                    tag,
                    {
                      props: {
                        label: item.title,
                        as: 'select-dense'
                      }
                    }
                  )
                }
              }
            }
          )
        ]
      ),
      h(
        components.select,
        {
          props: {
            value: this.suggestion.address,
            label: this.getTranslate(`${Services.requisites}.labels.suggestions.address`),
            hint: this.getTranslate(`${Services.requisites}.hints.suggestions.address`),
            dense: true,
            details: true,
            clearable: true,
            combobox: true,
            hideSelections: true,
            loading: this.loading.address,
            items: this.suggestions.address
          },
          on: {
            search: event => {
              this.getSuggestions(event, 'address')
            },
            input: event => {
              this.suggestion.address = event
            }
          },
          scopedSlots: {
            selection: ({ item }) => {
              return h(
                tag,
                {
                  props: {
                    label: item.title,
                    as: 'select-dense'
                  }
                }
              )
            }
          }
        }
      ),
      h(
        info,
        {
          props: {
            value: this.getTranslate(`${Services.requisites}.hints.suggestion`),
            color: Colors.primary
          }
        }
      )
    ]
  )
}

function renderContact(h) {
  let contactAccentColor = Colors.error
  if (this.contactValidation) {
    contactAccentColor = Colors.success
  }

  return h(
    components.card,
    {
      class: `${Services.requisites}-form__section`,
      props: {
        title: this.getTranslate(`${Services.requisites}.subheaders.contact`),
        outline: true,
        rounded: true,
        dashed: true,
        accentColorName: contactAccentColor
      }
    },
    [
      renderValidation.call(this, h, this.contactValidation),

      h(
        components.switch,
        {
          props: {
            value: this.contactMatches,
            label: this.getTranslate(`${Services.requisites}.labels.contact.matches`),
            outline: true
          },
          on: {
            input: event => {
              this.contactMatches = event
            }
          }
        }
      ),

      h(
        'div',
        {
          class: `${Services.requisites}-form__row`
        },
        [
          h(
            'div',
            {
              class: `${Services.requisites}-form__column`
            },
            [
              h(
                components['text-field'],
                {
                  attrs: { id: `${Services.requisites}.form.contact.lastName` },
                  props: {
                    value: this.proxy.contact.lastName,
                    label: this.getTranslate(`${Services.requisites}.labels.contact.lastName`),

                    disabled: this.contactMatches,
                    loading: this.loading.owner,
                    dense: true,
                    clearable: true,
                    details: false,
                    required: true
                  },
                  on: {
                    input: event => {
                      this.proxy.contact.lastName = event
                    }
                  }
                }
              ),

              h(
                components['text-field'],
                {
                  attrs: { id: `${Services.requisites}.form.contact.firstName` },
                  props: {
                    value: this.proxy.contact.firstName,
                    label: this.getTranslate(`${Services.requisites}.labels.contact.firstName`),

                    disabled: this.contactMatches,
                    loading: this.loading.owner,
                    dense: true,
                    clearable: true,
                    details: false,
                    required: true
                  },
                  on: {
                    input: event => {
                      this.proxy.contact.firstName = event
                    }
                  }
                }
              ),

              h(
                components['text-field'],
                {
                  props: {
                    value: this.proxy.contact.middleName,
                    label: this.getTranslate(`${Services.requisites}.labels.contact.middleName`),

                    disabled: this.contactMatches,
                    loading: this.loading.owner,
                    dense: true,
                    clearable: true,
                    details: false
                  },
                  on: {
                    input: event => {
                      this.proxy.contact.middleName = event
                    }
                  }
                }
              )
            ]
          ),

          h(
            'div',
            {
              class: `${Services.requisites}-form__column`
            },
            [
              h(
                components['text-field'],
                {
                  attrs: { id: `${Services.requisites}.form.contact.email` },
                  props: {
                    value: this.proxy.contact.email,
                    label: this.getTranslate(`${Services.requisites}.labels.contact.email`),
                    error: this.emailValidation,

                    disabled: this.contactMatches,
                    loading: this.loading.owner,
                    dense: true,
                    clearable: true,
                    details: false,
                    required: true
                  },
                  on: {
                    input: event => {
                      this.proxy.contact.email = event
                    }
                  }
                }
              ),

              h(
                components['text-field'],
                {
                  attrs: {
                    id: `${Services.requisites}.form.contact.phone`,
                    type: 'text'
                  },
                  props: {
                    value: this.proxy.contact.phone,
                    label: this.getTranslate(`${Services.requisites}.labels.contact.phone`),
                    error: this.phoneValidation,

                    disabled: this.contactMatches,
                    loading: this.loading.owner,
                    dense: true,
                    details: false,
                    required: true
                  },
                  on: {
                    input: event => {
                      this.proxy.contact.phone = event
                    }
                  }
                }
              )
            ]
          )
        ]
      )
    ]
  )
}

function renderSigner(h) {
  let signerAccentColor = Colors.error
  if (this.signerValidation) {
    signerAccentColor = Colors.success
  }

  return h(
    components.card,
    {
      class: `${Services.requisites}-form__section`,
      props: {
        title: this.getTranslate(`${Services.requisites}.subheaders.signer`),
        outline: true,
        rounded: true,
        dashed: true,
        accentColorName: signerAccentColor
      }
    },
    [
      renderValidation.call(this, h, this.signerValidation),

      h(
        'div',
        {
          class: `${Services.requisites}-form__row`
        },
        [
          h(
            components.card,
            {
              class: `${Services.requisites}-form__section`,
              props: {
                title: this.getTranslate(`${Services.requisites}.hints.nominative`),
                outline: true,
                rounded: true,
                dashed: true
              }
            },
            [
              h(
                components['text-field'],
                {
                  props: {
                    value: this.proxy.signer.fullName.nominative,
                    label: this.getTranslate(`${Services.requisites}.labels.signer.fullName.nominative`),
                    dense: true,
                    clearable: true,
                    details: false,
                    required: true,
                    validateOnBlur: true
                  },
                  on: {
                    input: event => {
                      this.setFullNameNominative(event)
                    }
                  }
                }
              ),
              h(
                components.select,
                {
                  props: {
                    value: this.proxy.signer.position.nominative,
                    label: this.getTranslate(`${Services.requisites}.labels.signer.position.nominative`),
                    items: requisitesPositions.nominative,
                    dense: true,
                    details: false,
                    combobox: true,
                    required: true,
                    setOnBlur: true,
                    hideSelections: true,
                    validateOnBlur: true
                  },
                  on: {
                    input: event => {
                      this.setSignerNominative(event, 'position')
                    }
                  }
                }
              ),
              h(
                components.select,
                {
                  props: {
                    value: this.proxy.signer.basis.nominative,
                    label: this.getTranslate(`${Services.requisites}.labels.signer.basis.nominative`),
                    items: requisitesBases.nominative,
                    dense: true,
                    details: false,
                    combobox: true,
                    required: true,
                    setOnBlur: true,
                    hideSelections: true,
                    validateOnBlur: true
                  },
                  on: {
                    input: event => {
                      this.setSignerNominative(event, 'basis')
                    }
                  }
                }
              )
            ]
          ),
          h(
            components.card,
            {
              class: `${Services.requisites}-form__section`,
              props: {
                title: this.getTranslate(`${Services.requisites}.hints.genitive`),
                outline: true,
                rounded: true,
                dashed: true
              }
            },
            [
              h(
                components['text-field'],
                {
                  props: {
                    value: this.proxy.signer.fullName.genitive,
                    label: this.getTranslate(`${Services.requisites}.labels.signer.fullName.genitive`),
                    dense: true,
                    clearable: true,
                    details: false,
                    required: true,
                    validateOnBlur: true
                  },
                  on: {
                    input: event => {
                      this.proxy.signer.fullName.genitive = event
                    }
                  }
                }
              ),
              h(
                components.select,
                {
                  props: {
                    value: this.proxy.signer.position.genitive,
                    label: this.getTranslate(`${Services.requisites}.labels.signer.position.genitive`),
                    items: requisitesPositions.genitive,
                    dense: true,
                    details: false,
                    combobox: true,
                    required: true,
                    setOnBlur: true,
                    hideSelections: true,
                    validateOnBlur: true
                  },
                  on: {
                    input: event => {
                      this.proxy.signer.position.genitive = event
                    }
                  }
                }
              ),
              h(
                components.select,
                {
                  props: {
                    value: this.proxy.signer.basis.genitive,
                    label: this.getTranslate(`${Services.requisites}.labels.signer.basis.genitive`),
                    items: requisitesBases.genitive,
                    dense: true,
                    details: false,
                    combobox: true,
                    required: true,
                    setOnBlur: true,
                    hideSelections: true,
                    validateOnBlur: true
                  },
                  on: {
                    input: event => {
                      this.proxy.signer.basis.genitive = event
                    }
                  }
                }
              )
            ]
          )
        ]
      )
    ]
  )
}

function renderVatTitle(h) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${Services.requisites}.titles.data.tax.vat`),
        size: sizes.small
      }
    }
  )
}
function renderVatButtons(h) {
  return [ true, false ].map(value => {
    return h(
      radioCard,
      {
        props: {
          value: this.proxy.data.tax.vat,
          cardValue: value,
          label: this.getTranslate(`${Services.requisites}.labels.data.tax.vat.${value}`),
          info: this.getTranslate(`${Services.requisites}.infos.vat.${value}`)
        },
        on: {
          input: event => {
            this.proxy.data.tax.vat = event
          }
        }
      }
    )
  })
}
function renderVat(h) {
  return h(
    'div',
    {
      class: `${Services.requisites}-form__row`
    },
    [ renderVatButtons.call(this, h) ]
  )
}
function renderLegal(h) {
  if (this.proxy.type === REQUISITE_TYPES.business) {
    let legalAccentColor = Colors.error
    if (this.legalValidation) {
      legalAccentColor = Colors.success
    }

    return h(
      components.card,
      {
        class: `${Services.requisites}-form__section`,
        props: {
          title: this.getTranslate(`${Services.requisites}.subheaders.legal`),
          outline: true,
          rounded: true,
          dashed: true,
          accentColorName: legalAccentColor
        }
      },
      [
        renderValidation.call(this, h, this.legalValidation),

        h(
          'div',
          {
            class: `${Services.requisites}-form__row`
          },
          [
            h(
              components.select,
              {
                props: {
                  value: this.proxy.data.legal.opf,
                  label: this.getTranslate(`${Services.requisites}.labels.data.legal.opf`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.legal.opf`),
                  items: requisitesOpfList,
                  dense: true,
                  details: true,
                  combobox: true,
                  required: true,
                  setOnBlur: true,
                  hideSelections: true,
                  validateOnBlur: true
                },
                on: {
                  input: event => {
                    this.proxy.data.legal.opf = event
                  }
                },
                scopedSlots: {
                  selection: ({ item }) => {
                    return h(
                      tag,
                      {
                        props: {
                          label: item.title,
                          as: 'select-dense'
                        }
                      }
                    )
                  }
                }
              }
            ),
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.legal.name,
                  label: this.getTranslate(`${Services.requisites}.labels.data.legal.name`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.legal.name`),

                  dense: true,
                  clearable: true,
                  details: true,
                  required: true,
                  validateOnBlur: true
                },
                on: {
                  input: event => {
                    this.proxy.data.legal.name = event
                  }
                }
              }
            ),
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.legal.inn,
                  label: this.getTranslate(`${Services.requisites}.labels.data.legal.inn`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.legal.inn`),
                  error: this.checkField(
                    this.proxy.data.legal.inn,
                    innRegExp,
                    this.getTranslate(`${Services.requisites}.errors.inn`)
                  ),

                  dense: true,
                  clearable: true,
                  details: true,
                  required: true,
                  validateOnBlur: true,
                  mask: /^\d{1,10}$|^\d{1,12}$/
                },
                on: {
                  input: event => {
                    this.proxy.data.legal.inn = event
                  }
                }
              }
            ),
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.legal.ogrn,
                  label: this.getTranslate(`${Services.requisites}.labels.data.legal.ogrn`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.legal.ogrn`),
                  error: this.checkField(
                    this.proxy.data.legal.ogrn,
                    ogrnRegExp,
                    this.getTranslate(`${Services.requisites}.errors.ogrn`)
                  ),

                  dense: true,
                  clearable: true,
                  details: true,
                  required: true,
                  validateOnBlur: true,
                  mask: /^\d{1,15}$/
                },
                on: {
                  input: event => {
                    this.proxy.data.legal.ogrn = event
                  }
                }
              }
            ),
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.legal.kpp,
                  label: this.getTranslate(`${Services.requisites}.labels.data.legal.kpp`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.legal.kpp`),
                  error: this.checkField(
                    this.proxy.data.legal.kpp,
                    kppRegExp,
                    this.getTranslate(`${Services.requisites}.errors.kpp`)
                  ),

                  dense: true,
                  clearable: true,
                  details: true,
                  mask: /^(\d{1,9})$/
                },
                on: {
                  input: event => {
                    this.proxy.data.legal.kpp = event
                  }
                }
              }
            ),
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.legal.okpo,
                  label: this.getTranslate(`${Services.requisites}.labels.data.legal.okpo`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.legal.okpo`),
                  error: this.checkField(
                    this.proxy.data.legal.okpo,
                    okpoRegExp,
                    this.getTranslate(`${Services.requisites}.errors.okpo`)
                  ),

                  dense: true,
                  clearable: true,
                  details: true,
                  mask: /^\d{1,8}$|^\d{1,10}$/
                },
                on: {
                  input: event => {
                    this.proxy.data.legal.okpo = event
                  }
                }
              }
            )
          ]
        ),

        renderVatTitle.call(this, h),
        renderVat.call(this, h)
      ]
    )
  }
}

function renderBank(h) {
  if (this.proxy.type === REQUISITE_TYPES.business) {
    let bankAccentColor = Colors.error
    if (this.bankValidation) {
      bankAccentColor = Colors.success
    }

    return h(
      components.card,
      {
        class: `${Services.requisites}-form__section`,
        props: {
          title: this.getTranslate(`${Services.requisites}.subheaders.bank`),
          outline: true,
          rounded: true,
          dashed: true,
          accentColorName: bankAccentColor
        }
      },
      [
        renderValidation.call(this, h, this.bankValidation),

        h(
          'div',
          {
            class: `${Services.requisites}-form__row`
          },
          [
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.bank.name,
                  label: this.getTranslate(`${Services.requisites}.labels.data.bank.name`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.bank.name`),

                  dense: true,
                  clearable: true,
                  details: true,
                  required: true,
                  validateOnBlur: true
                },
                on: {
                  input: event => {
                    this.proxy.data.bank.name = event
                  }
                }
              }
            ),
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.bank.rs,
                  label: this.getTranslate(`${Services.requisites}.labels.data.bank.rs`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.bank.rs`),
                  error: this.checkField(
                    this.proxy.data.bank.rs,
                    rsRegExp,
                    this.getTranslate(`${Services.requisites}.errors.rs`)
                  ),

                  dense: true,
                  clearable: true,
                  details: true,
                  required: true,
                  validateOnBlur: true,
                  mask: /^\d{1,20}$/
                },
                on: {
                  input: event => {
                    this.proxy.data.bank.rs = event
                  }
                }
              }
            ),
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.bank.ks,
                  label: this.getTranslate(`${Services.requisites}.labels.data.bank.ks`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.bank.ks`),
                  error: this.checkField(
                    this.proxy.data.bank.ks,
                    ksRegExp,
                    this.getTranslate(`${Services.requisites}.errors.ks`)
                  ),

                  dense: true,
                  clearable: true,
                  details: true,
                  required: true,
                  validateOnBlur: true,
                  mask: /^\d{1,20}$/
                },
                on: {
                  input: event => {
                    this.proxy.data.bank.ks = event
                  }
                }
              }
            ),
            h(
              components['text-field'],
              {
                props: {
                  value: this.proxy.data.bank.bik,
                  label: this.getTranslate(`${Services.requisites}.labels.data.bank.bik`),
                  hint: this.getTranslate(`${Services.requisites}.hints.data.bank.bik`),
                  error: this.checkField(
                    this.proxy.data.bank.bik,
                    bikRegExp,
                    this.getTranslate(`${Services.requisites}.errors.bik`)
                  ),

                  dense: true,
                  clearable: true,
                  details: true,
                  required: true,
                  validateOnBlur: true,
                  mask: /^\d{1,9}$/
                },
                on: {
                  input: event => {
                    this.proxy.data.bank.bik = event
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}

function renderLegalAddress(h) {
  let legalAddressAccentColor = Colors.error
  if (this.legalAddressValidation) {
    legalAddressAccentColor = Colors.success
  }

  return h(
    components.card,
    {
      class: `${Services.requisites}-form__section`,
      props: {
        title: this.getTranslate(`${Services.requisites}.subheaders.legalAddress`),
        outline: true,
        rounded: true,
        dashed: true,
        accentColorName: legalAddressAccentColor
      }
    },
    [
      renderValidation.call(this, h, this.legalAddressValidation),

      h(
        requisitesFormAddress,
        {
          props: {
            value: this.proxy.data.legalAddress
          },
          on: {
            input: event => {
              this.proxy.data.legalAddress = event
            }
          }
        }
      )
    ]
  )
}

function renderPostalAddress(h) {
  let postalAddressAccentColor = Colors.error
  if (this.postalAddressValidation) {
    postalAddressAccentColor = Colors.success
  }

  return h(
    components.card,
    {
      class: `${Services.requisites}-form__section`,
      props: {
        title: this.getTranslate(`${Services.requisites}.subheaders.postalAddress`),
        outline: true,
        rounded: true,
        dashed: true,
        accentColorName: postalAddressAccentColor
      }
    },
    [
      renderValidation.call(this, h, this.postalAddressValidation),

      h(
        requisitesFormAddress,
        {
          props: {
            value: this.proxy.data.postalAddress,
            address: this.proxy.data.legalAddress,
            matches: this.proxy.type === REQUISITE_TYPES.business
          },
          on: {
            input: event => {
              this.proxy.data.postalAddress = event
            }
          }
        }
      )
    ]
  )
}

function renderOwner(h) {
  return h(
    selectorOwner,
    {
      style: { 'max-width': '50%' },
      props: {
        value: this.proxy.OwnerId,
        hint: this.getTranslate(`${Services.requisites}.hints.owner`),
        dense: true,
        combobox: true,
        disabled: !!this.OwnerId
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: `${Services.requisites}-form`
    },
    [
      renderAutoFilling.call(this, h),
      renderContact.call(this, h),
      renderSigner.call(this, h),
      renderLegal.call(this, h),
      renderBank.call(this, h),
      renderLegalAddress.call(this, h),
      renderPostalAddress.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}
